import { Component, DestroyRef, effect, inject, input, signal } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dsm-changes-saved',
  template: `
    @if (show()) {
      <div class="changes-saved-msg flex items-center gap-1 whitespace-nowrap shrink-0" role="status">
        <i class="pi pi-check-circle"></i>
        <span>Changes saved</span>
      </div>
    }
  `,
  styles: [
    `
      @keyframes jumpIn {
        0% {
          opacity: 0;
          transform: translateY(10px);
        }
        50% {
          opacity: 1;
          transform: translateY(-3px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .changes-saved-msg {
        color: #16a34a;
        font-size: 0.688rem;
        font-weight: 500;
        white-space: nowrap;
        animation: jumpIn 0.4s ease-out;
      }
    `
  ]
})
export class DsmChangesSavedComponent {
  readonly savedAt = input<number>(0);
  readonly duration = input<number>(3000);

  protected readonly show = signal(false);
  #timer: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    const destroyRef = inject(DestroyRef);

    effect(() => {
      const trigger = this.savedAt();
      if (trigger === 0) return; // skip initial value

      this.show.set(true);
      if (this.#timer) clearTimeout(this.#timer); // cancel any in-flight hide
      this.#timer = setTimeout(() => this.show.set(false), this.duration());
    });

    destroyRef.onDestroy(() => {
      if (this.#timer) clearTimeout(this.#timer);
    });
  }
}
